<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-divide class="table-tools">
      <div></div>
      <n-link v-if="edit.toCreate" :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>

    <n-table :columns="columns" :data="data">
      <template #headerRow>
        <tr class="header">
          <td rowspan="3">Дата</td>
          <td rowspan="3">Границы участка, км, пк</td>
          <td rowspan="3">Температура воздуха °С</td>
          <td colspan="5">Изоляция</td>
          <td colspan="3">Качество изоляции соответствует проекту и техническим требованиям</td>
          <td colspan="8">Укладка и балластировка</td>
          <td colspan="3">Выполненные работы по укладке и балластировке соответствуют техническим требованиям и проекту </td>
          <td rowspan="3">Примечания</td>
          <td></td>
        </tr>
        <tr class="header">
          <td rowspan="2">вид (п.бр. и т.д.) т и п (У, Н) конструкция (1 1, 1 2, 2 2 и т.п.)</td>
          <td rowspan="2">Марка клея (Праймера) и марка изоляционной ленты, к-во слоев</td>
          <td rowspan="2">Марка оберточного материала, к-во слоев </td>
          <td colspan="2">Сведения о производственном контроле качества выполняемых работ </td>
          <td rowspan="2">Ф.,И., О., подпись ответственного исполнителя </td>
          <td rowspan="2">Ф.,И.,О., подпись ответственного представителя службы контроля качества</td>
          <td rowspan="2">Ф.,И.,О., подпись представителя технадзора заказчика</td>
          <td colspan="3">Сведения о производственном контроле укладки трубопровода на проектные отметки </td>
          <td colspan="2">Ремонт изоляции после укладки выполнен </td>
          <td rowspan="2">Границы участка балластировки от км (пк) до км (пк) </td>
          <td rowspan="2">Тип, вес балластировочных устройств, удерживающая способность анкерных устройств</td>
          <td rowspan="2">Шаг пригрузки</td>
          <td rowspan="2">Ф.,и.,о. подпись ответственного исполнителя</td>
          <td rowspan="2">Ф.,и.,о. подпись ответственного представителя службы контроля качества</td>
          <td rowspan="2">Ф.,и.,о. подпись представителя технадзора заказчика</td>
          <td></td>
        </tr>
        <tr class="header">
          <td>метод контроля </td>
          <td>Ф.,И.,О., подпись лица, ответственного за выполнение операционного контроля</td>
          <td>проектные отметки верха трубы после укладки </td>
          <td>фактические отметки верха трубы после укладки </td>
          <td>проверку выполнил, Ф.,И.,О., подпись геодезиста </td>
          <td>Ф.,И.,О., подпись ответственного исполнителя  </td>
          <td>Ф.,И.,О., подпись представителя технадзора   </td>
          <td></td>
        </tr>
        <tr class="header">
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
          <td>7</td>
          <td>8</td>
          <td>9</td>
          <td>10</td>
          <td>11</td>
          <td>12</td>
          <td>13</td>
          <td>14</td>
          <td>15</td>
          <td>16</td>
          <td>17</td>
          <td>18</td>
          <td>19</td>
          <td>20</td>
          <td>21</td>
          <td>22</td>
          <td>23</td>
          <td></td>
        </tr>
      </template>
      <template #date="{item}">
        {{ $app.date.format(item.date) }}
      </template>


      <template #responsibleSign="{item}">
        <c-journal-sign :sign="getSign(item, 'responsible')" />
      </template>
      <template #executorSign="{item}">
        <c-journal-sign :sign="getSign(item, 'executor')" />
      </template>
      <template #placeExecutorSign="{item}">
        <c-journal-sign :sign="getSign(item, 'place.executor')" />
      </template>
      <template #doneExecutorSign="{item}">
        <c-journal-sign :sign="getSign(item, 'done.executor')" />
      </template>
      <template #qualitySign="{item}">
        <c-journal-sign :sign="getSign(item, 'quality')" />
      </template>
      <template #doneQualitySign="{item}">
        <c-journal-sign :sign="getSign(item, 'done.quality')" />
      </template>
      <template #placeTechSign="{item}">
        <c-journal-sign :sign="getSign(item, 'place.tech')" />
      </template>
      <template #doneTechSign="{item}">
        <c-journal-sign :sign="getSign(item, 'done.tech')" />
      </template>
      <template #techSign="{item}">
        <c-journal-sign :sign="getSign(item, 'tech')" />
      </template>
      <template #geodesistSign="{item}">
        <c-journal-sign :sign="getSign(item, 'geodesist')" />
      </template>


      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)"><n-button icon="eye" /></n-link>
      </template>
    </n-table>

    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(showRecordLink(false))" />
  </div>
</template>

<script>
import PageRecordCreate from './Create'
import ModalRecord from './record/Index'
import utils from 'utils'
import CJournalSign from 'components/journal/Sign'

export default {
  name: 'MainChapter4',
  components: { ModalRecord, PageRecordCreate, CJournalSign, },
  props: [ 'project', 'journal', ],
  data: () => ({
    utils,
    data: [
    ],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    edit() {
      return {
        toCreate: $app.auth.can('journals_'+this.journal.name+'_executor', this.project.id),
      }
    },
    columns() {
      return [
        { name: 'date', title: '', },
        { name: 'border', title: '', },
        { name: 'airTemp', title: '', },
        { name: 'isolation1', title: '', },
        { name: 'isolation2', title: '', },
        { name: 'isolation3', title: '', },
        { name: 'isolation4', title: '', },
        { name: 'responsibleSign', title: '', },
        { name: 'executorSign', title: '', },
        { name: 'qualitySign', title: '', },
        { name: 'techSign', title: '', },
        { name: 'placing1', title: '', },
        { name: 'placing2', title: '', },
        { name: 'geodesistSign', title: '', },
        { name: 'placeExecutorSign', title: '', },
        { name: 'placeTechSign', title: '', },
        { name: 'placing6', title: '', },
        { name: 'placing7', title: '', },
        { name: 'placing8', title: '', },
        { name: 'doneExecutorSign', title: '', },
        { name: 'doneQualitySign', title: '', },
        { name: 'doneTechSign', title: '', },
        { name: 'remark', title: '', },

        { name: 'tools', title: '', },
      ]
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name)
        .query({
          'with[records][with][participation]': null,
          'with[signs][with][author]': null,
          projectId: this.project.id,
        })
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    getUser(item, name) {
      if (!item[name]) {
        return ''
      }
      return item[name]?.participation?.position + ', ' + item[name]?.fullName
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
